import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

import { DialogTrigger } from "../ui/Dialog";
import logo from "~/assets/elistech-logo.svg";
import { useTranslation } from "~/i18n";

interface HeaderProps {
  sidebarOpen: boolean;
}

export function Header({ sidebarOpen }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="brand-gradient fixed inset-x-0 top-0 z-50 flex h-14 items-center px-4 shadow-md lg:hidden">
      <DialogTrigger asChild>
        <button
          type="button"
          className="pointer-events-auto cursor-pointer rounded-md p-1.5 text-white transition-colors hover:bg-white/10"
          aria-label={
            sidebarOpen
              ? t("navigation.drawer.closeMenu")
              : t("navigation.drawer.openMenu")
          }
        >
          {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </DialogTrigger>
      <Link to="/" className="absolute left-1/2 -translate-x-1/2">
        <img src={logo} alt="ElisTech" className="h-7 w-auto" />
      </Link>
    </header>
  );
}
